import { cn } from "@/lib/utils";

/**
 * Shared hero band for marketing subpages: the homepage's pale-yellow wash,
 * one H1 scale, one subtitle style. Replaces the per-page ad-hoc headers and
 * the app-style "Back" buttons (the nav handles wayfinding).
 *
 * `containerClassName` should match the page's own content container width
 * (e.g. "max-w-3xl") so the title lines up with the content below it.
 */
export default function MarketingPageHeader({
  title,
  subtitle,
  eyebrow,
  containerClassName,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  containerClassName?: string;
}) {
  return (
    <section>
      <div className={cn("container mx-auto px-4 pt-32 pb-12", containerClassName)}>
        {eyebrow && <div className="mb-4">{eyebrow}</div>}
        <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground tracking-tight text-balance">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
